export default "__VITE_ASSET__Cu8$5W8C__"